module.exports = __webpack_public_path__ + "static/img/lightimelogo.7a41830.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lightimelogo.png
// module id = 1rcP
// module chunks = 1